import { apiUrl } from '../config/api'

export async function listEventsByClient(clientId) {
  let params = {
    clientId: clientId
  }

  let url = apiUrl('ListMonthEventsForCalendarByClient')

  return sendReq(params, url)
}

export async function listExpirationsByClient(clientId, includeNotVisible) {
  let params = {
    clientId: clientId,
    includeNotVisible: includeNotVisible
  }

  let url = apiUrl('ListMonthExpirationsForCalendarByClient')

  return sendReq(params, url)
}

export async function listExpirationsByBrandLabel() {
  let params = {
    brandLabel: window.$brand
  }

  let url = apiUrl('ListMonthExpirationsForCalendar')

  return sendReq(params, url)
}

export async function listEventsByBrandLabel() {
  let params = {
    brandLabel: window.$brand
  }

  let url = apiUrl('ListMonthEventsForCalendar')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, { method: 'POST', body: JSON.stringify(params) })
  return res.json()
}
